import React, { useState } from 'react';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import '@/pages/intelligence/assets/scss/TopCharts/MobileGames/index.scss';
import { history, useIntl } from 'umi';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import UpcomingMobileGame from './MobileGame';
import UpcomingPCGame from './PCGame';
import UpcomingConsoleGame from './ConsoleGame';
const { Content } = Layout;


export default function UpcomingGames(props: any) {
  const [activeId, setActiveId] = useState(props?.match?.params?.tab || 'MobileGames');
  const [bodyLoading, setBodyLoading] = useState(false);
  const { formatMessage } = useIntl();

  const tabs = [
    {
      id: 'MobileGames',
      label: formatMessage({ id: 'dbi_label_mobile_games' }),
      component: <UpcomingMobileGame />,
    },
    {
      id: 'PCGames',
      label: formatMessage({ id: 'dbi_label_pc_games' }),
      component: <UpcomingPCGame />
    },
    {
      id: 'ConsoleGames',
      label: formatMessage({ id: 'dbi_label_console_games' }),
      component: <UpcomingConsoleGame />,
    },
  ];
  return (
    <Content>
      <Content.Header
        title={formatMessage({ id: 'dbi_label_upcoming_games' })}
        className="contentHead-normal">
        <div className="header-tab">
          <Tabs
            ceiling
            newMarkIdsMappingKey="PotentialUpcomingGames"
            tabs={tabs}
            animated={false}
            activeId={activeId}
            onActive={(tab) => {
              setActiveId(tab.id);
              setBodyLoading(true);
              setTimeout(() => {
                setBodyLoading(false);
              }, 0);
              history.replace(
                `/intelligence/potential/upcomingGames/${tab.id}`,
              );
            }}
          />
        </div>
      </Content.Header>
      {bodyLoading ? null : (
        <Content.Body full>
          <MarqueeBanner />
          {tabs.map((e) => <div key={e.id}>{e.id == activeId ? e.component : ''}</div>)}
        </Content.Body>
      )}
    </Content>
  );
}

// export default connect((state: any) => {
//   return {
//     topchartsState: state[DBI_TOPCHARTS],
//   };
// })(MobileGames);
